import { GETAPI, POSTAPI, POSTASFORMDATA } from "../../API/Api";
import { ApiConfig } from "../../Config/CommonConfig";
import {
  GET_QUESTIONS_LIST_FAIL,
  GET_QUESTIONS_LIST_REQUEST,
  GET_QUESTIONS_LIST_SUCCESS,
  QUESTION_DETAILS_FAIL,
  QUESTION_DETAILS_REQUEST,
  QUESTION_DETAILS_SUCCESS,
  QUESTION_VERIFY_FAIL,
  QUESTION_VERIFY_REQUEST,
  QUESTION_VERIFY_SUCCESS,
  EXTRACT_QUESTION_PDF_FAIL,
  EXTRACT_QUESTION_PDF_REQUEST,
  EXTRACT_QUESTION_PDF_SUCCESS,
  BULK_CREATE_MCQ_FAIL,
  BULK_CREATE_MCQ_REQUEST,
  BULK_CREATE_MCQ_SUCCESS,
} from "../../Constants/QuestionVerifyConstants";
import { Dispatch } from "react";

export const QuestionListAction =
  (payload: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: GET_QUESTIONS_LIST_REQUEST });

      let data = await GETAPI(ApiConfig?.VerifyQuestion + payload);

      if (data && data.status === true) {
        dispatch({
          type: GET_QUESTIONS_LIST_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: GET_QUESTIONS_LIST_FAIL,
          data: [],
        });
      }
    } catch (error) {}
  };

export const QuestionDetailsAction =
  (payload: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: QUESTION_DETAILS_REQUEST });

      let data = await GETAPI(ApiConfig?.VerifyQuestion + payload);

      if (data && data.status === true) {
        dispatch({
          type: QUESTION_DETAILS_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: QUESTION_DETAILS_FAIL,
          data: null,
        });
      }
    } catch (error) {}
  };

export const QuestionVerifyAction =
  (params: string, payload: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: QUESTION_VERIFY_REQUEST });
      let data = await POSTAPI(
        ApiConfig?.VerifyQuestion + params,
        payload,
        true
      );

      if (data && data.status === true) {
        dispatch({
          type: QUESTION_VERIFY_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: QUESTION_VERIFY_FAIL,
          data: [],
        });
      }
    } catch (error) {}
  };

export const ExtractQuestionPdfAction =
  (payload: FormData) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: EXTRACT_QUESTION_PDF_REQUEST });
      let data = await POSTASFORMDATA(ApiConfig?.PdfExtract, payload, true);

      if (data && data.status === true) {
        dispatch({
          type: EXTRACT_QUESTION_PDF_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: EXTRACT_QUESTION_PDF_FAIL,
          data: null,
        });
      }
    } catch (error) {
      dispatch({
        type: EXTRACT_QUESTION_PDF_FAIL,
        data: null,
      });
    }
  };

export const BulkCreateMCQAction =
  (payload: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: BULK_CREATE_MCQ_REQUEST });
      let data = await POSTAPI(ApiConfig?.BulkCreateMCQ, payload, true);

      if (data && data.status === true) {
        dispatch({
          type: BULK_CREATE_MCQ_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: BULK_CREATE_MCQ_FAIL,
          data: null,
        });
      }
    } catch (error) {
      dispatch({
        type: BULK_CREATE_MCQ_FAIL,
        data: null,
      });
    }
  };
